/**
* Video Component JS
* -----------------------------------------------------------------------------
*
* All the JS for the Video Component component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
( function( app ) {
  const COMPONENT = {

    className: 'video-component',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      // gsap.registerPlugin( ScrollTrigger );
      $( '.video-component__slider' ).slick( {
        slidesToShow: 4,
        slidesToScroll: 1,
        cssEase: 'cubic-bezier( 0.390, 0.575, 0.565, 1.000 )',
        dots: false,
        arrows: true,
        appendArrows: $( '.video-component__arrow-container' ),
        prevArrow: '<div type="button" class="flex items-center justify-center slick-prev"><svg class="ml-1 icon icon-right-chevron-white text-white text-base"><use xlink:href="#icon-right-chevron-white"></use></svg></div>',
        nextArrow: '<div type="button" class="flex items-center justify-center slick-prev mr-6"><svg class="icon icon-right-chevron-white text-white text-base transform rotate-180"><use xlink:href="#icon-right-chevron-white"></use></svg></div>',
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 3,
            },
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 1,
            },
          },
        ],
      } );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'video-component', COMPONENT );
} )( app );
